// removed by extract-text-webpack-plugin
module.exports = {"main_right_content":"components-fwwgl-lxfs-index-main_right_content-29Sef","table":"components-fwwgl-lxfs-index-table-vLNJj"};


//////////////////
// WEBPACK FOOTER
// ./components/fwwgl/lxfs/index.css
// module id = 2285
// module chunks = 0